import { Outlet } from "react-router-dom"
const MainManHour = () =>{
    return(
        <div className=" w-full h-full">
         <Outlet/>
        </div>
    )
}

export default MainManHour;